import React from 'react';
import {MDCDialog,MDCTextArea,MDCIconTextInput} from '../components/mdc-components';

export class TweetDialog extends React.Component{
    constructor(props){
       super(props);
    }

    onDialogAccept(){
       var code=this.input.value;
       this.input.value='';
       code = code.replace(/<script[^>]*>(?:(?!<\/script>)[^])*<\/script>/g, "")
       if(this.props.onDialogAccept) this.props.onDialogAccept(code);
    }

    show(){
      this.dialog.show(); 
    }

    render(){
        return(
           <MDCDialog header="Embed Tweet" onDialogAccept={this.onDialogAccept.bind(this)} ref={(ref) => this.dialog = ref}>
              <MDCTextArea label="Embed Code" id="tweetEmbedCode" ref={(ref) => this.input = ref} />
           </MDCDialog>
        )
    }
}

export class YoutubeDialog extends React.Component{
    constructor(props){
       super(props);
    }

    onDialogAccept(){
       var url=this.input.value;
       this.input.value='';
       var id = this.getVideoId(url);
       var html=this.getEmbedCode(id);
       if(this.props.onDialogAccept) {
           this.props.onDialogAccept(html);
       }
    }

    show(){
      this.dialog.show(); 
    }

    getVideoId(str){
        var split=str.split('?v=');
        if(split.length >1) return split[1];
        else return str;
    }

    getEmbedCode(id){
        return '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + id + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    }


    render(){
        return(
           <MDCDialog header="Video Link" onDialogAccept={this.onDialogAccept.bind(this)} ref={(ref) => this.dialog = ref}>
              <MDCIconTextInput icon="link" label="Video Link" id="videoLink" ref={(ref) => this.input = ref} />
           </MDCDialog>
        )
    }
}

export class ColorSelection extends React.Component{
    render(){
        var style = {
          background:this.props.color
        };
        return(
            <div data-color={this.props.color} style={style} />
        )
    }
}

export default {TweetDialog,YoutubeDialog,ColorSelection}